import { render, staticRenderFns } from "./redirectUrlNullPlate.vue?vue&type=template&id=1ee7c189&scoped=true&"
import script from "./redirectUrlNullPlate.vue?vue&type=script&lang=js&"
export * from "./redirectUrlNullPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee7c189",
  null
  
)

export default component.exports